<p class="clearfix mb-0 text-center">
    <span class="d-block mt-25">
        COPYRIGHT &copy; 2023-{{ year }}
        <a class="ml-25" href="https://www.softsquareit.com/" target="_blank">SoftSquare IT</a>
        <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>
</p>